export default "__VITE_ASSET__DwvI9SSi__"